<template>
    <div>
        <el-dialog
            :title="'批量预设站点'"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="800px">
            <div class="formContent">
                <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="left">
                    <el-form-item label="选择文件" prop="taxFiles">
                        <multi-file-choose
                            ref="uploadFile"
                            :taxFiles.sync="form.taxFiles"
                            :max="1"
                            :accept="'.xlsx'"
                            :placeholder="'只能选择.xlsx文件'"
                        />
                        <div class="tips">
                            <span>1.卡片须提前导入。</span>
                        </div>
                    </el-form-item>
                </el-form>
                <p class="a-fs-14 a-c-333 a-fw-700" v-if="errorData.length">以下卡片导入失败：</p>
                <el-table 
                    v-if="errorData.length"
                    ref="errorList"
                    :data="errorData" 
                    :highlight-current-row="true" 
                    style="width: 100%">
                    <el-table-column prop="" label="卡号" width="180">
                        <template slot-scope="{ row }">
                            <span>{{ row.cardNo || '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="失败原因" >
                        <template slot-scope="{ row }">
                            <span>{{ row.failMessage || '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div slot="footer" class="a-flex-rfsc">
                <div class="a-flex-1 a-flex-rfsc">
                    <el-link type="primary" underline @click="handleDownloadFile">模版下载</el-link>
                </div>
                <el-button class="plainBtn" @click="dialogVisible = false">取消</el-button>
                <el-button type="primary"  @click="submit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import MultiFileChoose from '../../components/formcy/multi-file-choose.vue';
    import * as XLSX from 'xlsx';
    export default {
        components: {
            MultiFileChoose
        },
        data() {
            return {
                dialogVisible: false,
                errorData: [],
                exportType: '',
                form: {
                    taxFiles: []
                },
                rules: {
                    taxFiles: [{required: true, message:'请先选择文件', trigger: 'change'}]
                }
            };
        },
        watch: {
            dialogVisible (val) {
                if (!val) {
                    this.errorData = [];
                    this.form.taxFiles = [];
                    this.$refs['uploadFile'].fileList = []
                }
            }
        },
        mounted () {

        },
        methods:{
            handleDownloadFile () {
                this.exportExcel([
                    {
                        '卡号': 'xxxxxxx',
                        '是否启用充值': '否',
                        '预设站点(ID)': 'xxxx',
                    }
                ], '卡片批量预设站点模版');
            },
            submit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$Axios._post({
                            url: this.$Config.apiUrl.chargeCardBatchSetStation,
                            params: {
                                url: this.form.taxFiles[0].url
                            }
                        }).then(({data}) => {
                            if(data && data.length) {
                                this.errorData = data;
                            }else{
                                this.dialogVisible = false;
                                this.$message.success('操作成功');
                                this.$emit('success')
                            }
                        }).catch((error) => {
                            
                        })
                    }
                })
            },
            exportExcel(data, fileName = '导出数据', options = {}) {
                // 1. 创建工作簿
                const workbook = XLSX.utils.book_new();
                // 2. 处理多Sheet情况
                if (Array.isArray(data)) {
                    // 单Sheet：直接是数组
                    const worksheet = XLSX.utils.json_to_sheet(data);
                    // 设置列宽
                    if (options.columnWidths) {
                        worksheet['!cols'] = options.columnWidths;
                    }
                    XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName || 'Sheet1');
                } else {
                    // 多Sheet：data是对象，key是sheet名，value是数组
                    Object.entries(data).forEach(([sheetName, sheetData]) => {
                        if (Array.isArray(sheetData) && sheetData.length > 0) {
                            const worksheet = XLSX.utils.json_to_sheet(sheetData);
                            XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                        }
                    });
                }
                
                // 3. 写入文件
                try {
                    XLSX.writeFile(workbook, `${fileName}.xlsx`);
                    console.log('Excel文件下载成功');
                    return true;
                } catch (error) {
                    console.error('Excel生成失败:', error);
                    return false;
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .a-mr-10{
        margin-right: 10px;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>